<template>
    <div v-if="setStore.total > 0" class="mt-2 flex items-center justify-between">
        <div class="flex flex-col">
            <span class="price text-4xl font-extrabold" v-text="formatPrice(setStore.total)" data-test-id="pdp-price" />

            <span v-if="setStore.hasDiscount" class="flex items-center gap-1">
                <span v-text="formatPrice(setStore.subtotal)" data-test-id="pdp-recommended-price" class="line-through" />
                <!-- A meerluik is sold as one product; the customer never sees a set to get a
                     set discount on, so the label would only raise questions. -->
                <span
                    v-if="!setStore.isPanelSet"
                    class="font-semibold text-prices"
                    v-text="$t('pages.product_detail_page.product_info.product_set.discount_label')"
                />
            </span>
        </div>

        <!-- DiscountBadge renders its value as a percentage, so an absolute set discount leaves
             discountPercentage null and stays in the struck-through price above instead. -->
        <DiscountBadge :discount="setStore.discountPercentage" size="3xl" />
    </div>
</template>

<script setup lang="ts">
import DiscountBadge from '@/components/badges/DiscountBadge.vue';
import { useFormatPrice } from '@/composables/useFormatPrice';
import { useProductSetStore } from '@/stores/products/ProductSetStore';

const formatPrice = useFormatPrice();
const setStore = useProductSetStore();
</script>
